import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnDesktop, OnMobile } from '@hopskipdrive/react-components';
import { useFlags } from '@rideiq/contexts/LDContext';
import { Button } from '@rideiq/shared/components/Button';

import { RiderCreationModal } from '../RiderCreationModal';

const CreateRider: FC = () => {
  const [showRiderCreationModal, setShowRiderCreationModal] = useState(false);
  const navigate = useNavigate();
  const { iepStructuredNotesEnabled } = useFlags();
  const useNewForm = iepStructuredNotesEnabled;

  const handleClick = () => {
    if (useNewForm) {
      navigate('/riders/new');
    } else {
      setShowRiderCreationModal(true);
    }
  };

  return (
    <>
      <OnDesktop>
        <Button color="primary" size="large" onClick={handleClick}>
          Create Rider
        </Button>
      </OnDesktop>
      <OnMobile>
        <Button color="primary" size="medium" onClick={handleClick}>
          Create Rider
        </Button>
      </OnMobile>
      {!useNewForm && (
        <RiderCreationModal
          isOpen={showRiderCreationModal}
          handleClose={() => setShowRiderCreationModal(false)}
          handleSelectRider={() => false}
        />
      )}
    </>
  );
};

export default CreateRider;
